<template>
  <h1
    class="title"
    :class="modifierClasses"
  >
    <span
      v-if="iconName"
      class="title__icon"
    ><icon
      :icon="iconName"
    /></span>
    <slot />
  </h1>
</template>

<script>
import icon from '@/components/base/svg/SVG.vue';

export default {
  name: 'Title',

  components: {
    icon,
  },

  props: {
    iconName: {
      type: String,
      required: false,
      default: null,
    },
    medium: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    modifierClasses() {
      return [
        (this.medium ? 'title--medium' : ''),
      ];
    },
  },

};
</script>

<style lang="scss" scoped>
.title {
  @include title-xs();

  font-family: $montserrat-bold;

  @include screen(tablet-up) {
    @include title-m();
  }
}

.title--medium {
  @include screen(tablet-up) {
    @include title-xs();
  }
}
</style>
